let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4NFU0")).then(() => parcelRequire('7T3TJ'));